import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-7051ff34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "demo-wrap" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row no-gutters" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-auto" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        class: "img-fluid",
        width: "70",
        height: "70",
        alt: "logo"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col d-flex align-items-center" }, [
      /*#__PURE__*/_createElementVNode("h1", { class: "h3 text-white mt-2" }, "สำนักงานคณะกรรมการกำกับและติดตามการปฏิบัติราชการในภูมิภาค")
    ])
  ])
], -1))
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "m-sm-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-5" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-white" }, "ยินดีต้อนรับ")
], -1))
const _hoisted_7 = { class: "panel" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "lead text-light" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "info" }, "กรุณาเข้าสู่ระบบด้วยชื่อบัญชีของคุณ")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-fw fa-arrow-alt-circle-right me-2" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", { class: "footer mt-auto py-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("a", {
      class: "text-light",
      href: "https://www.otps.go.th",
      target: "_blank"
    }, [
      /*#__PURE__*/_createElementVNode("span", { class: "fas fa-globe me-2" }),
      /*#__PURE__*/_createTextVNode("เว็บไซต์ ส.กกภ.")
    ]),
    /*#__PURE__*/_createElementVNode("a", {
      class: "text-light",
      href: "https://www.otps.go.th/downloads/manual.pdf"
    }, [
      /*#__PURE__*/_createElementVNode("span", { class: "fas fa-book me-2" }),
      /*#__PURE__*/_createTextVNode("คู่มือการใช้งาน")
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackgroundComponent = _resolveComponent("BackgroundComponent")!

  return (_openBlock(), _createBlock(_component_BackgroundComponent, { theme: "bubble" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("button", {
                  class: "btn btn-primary mt-3",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.authClick && _ctx.authClick(...args)))
                }, [
                  _hoisted_9,
                  _createTextVNode("เข้าสู่ระบบ ")
                ])
              ])
            ])
          ])
        ]),
        _hoisted_10
      ])
    ]),
    _: 1
  }))
}